var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.8155C0 4.14048 0.547207 3.59326 1.22222 3.59326H8.99851C9.67353 3.59326 10.2207 4.14048 10.2207 4.8155C10.2207 5.49052 9.67353 6.03773 8.99851 6.03773H2.44444V19.5553H15.9619V13.0012C15.9619 12.3261 16.5091 11.7789 17.1841 11.7789C17.8591 11.7789 18.4063 12.3261 18.4063 13.0012V20.7775C18.4063 21.4526 17.8591 21.9998 17.1841 21.9998H1.22222C0.547207 21.9998 0 21.4526 0 20.7775V4.8155Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77783 9.77789L17.1112 2.44447L19.5556 4.88894L12.2223 12.2224H10.2778C10.0017 12.2224 9.77783 11.9985 9.77783 11.7224V9.77789Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1667 4.27783L17.7223 1.83335L18.4949 1.06068C19.0807 0.474884 20.0305 0.474884 20.6163 1.06068L20.9394 1.38382C21.5252 1.9696 21.5252 2.91934 20.9394 3.50513L20.1667 4.27783Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.4520cd47797122890e4dad7bc9313c76.svg";
export { ForwardRef as ReactComponent };